import "../../App.css";
import React, { useEffect, useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  Grid,
  Typography,
  Button,
  Divider,
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
// import "./requestManage-styles.css";
import { Modal as BootstrapModal } from "react-bootstrap";
import remove from "../../images/remove.png";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

const PreviewMore20 = ({ setFiles3, fileDescriptions3, files3 }) => {
  // const [files3, setFiles3] = useState(Array(fileDescriptions3.length).fill(null));
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [completedModal, setCompletedModal] = useState(false);
  const [toggleImg, setToggleImg] = useState(false);
  const [textModal, setTextModal] = useState("");
  const allowedFileTypes = ["image/jpeg", "image/png", "application/pdf"];
  const allowedFileExtensions = [".jpeg", ".jpg", ".png", ".pdf"];

  useEffect(() => {}, [setFiles3]);

  const onDrop = useCallback(
    (acceptedFiles, index) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];

        if (
          !allowedFileTypes.includes(file.type) &&
          !allowedFileExtensions.some((ext) =>
            file.name.toLowerCase().endsWith(ext)
          )
        ) {
          const updatedFiles = [...files3];
          updatedFiles[index] = null;
          setFiles3(updatedFiles);

          setTextModal(
            `ไฟล์ "${file.name}" ไม่สามารถอัพโหลดได้ (รองรับเฉพาะไฟล์ .jpeg, .jpg, .png, .pdf)`
          );
          setCompletedModal(true);
          return;
        }

        const updatedFiles = [...files3];
        updatedFiles[index] = Object.assign(file, {
          preview: URL.createObjectURL(file),
        });
        setFiles3(updatedFiles);
      }
    },
    [files3]
  );

  const createDropzoneProps = (index) => {
    return useDropzone({
      onDrop: (acceptedFiles) => onDrop(acceptedFiles, index),
      accept: {
        "image/*": [],
        "application/pdf": [],
      },
      multiple: false,
    });
  };

  const handleClickOpen = (files3) => {
    setSelectedFile(files3);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedFile(null);
  };

  return (
    <div style={{ padding: 40 }}>
      {/* // Component ที่แสดงเมื่อ flagRelation เป็น true */}
      <Grid container spacing={2}>
        {fileDescriptions3.map((description, index) => {
          const { getRootProps, getInputProps } = createDropzoneProps(index);
          const file = files3[index];

          return (
            <Grid container spacing={1} key={index} sx={{ mb: 2 }}>
              {/* คำอธิบาย */}
              <Grid item xs={12} md={10} sx={{ order: { xs: 1, md: 1 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", fontFamily: "Prompt-Thin" }}
                >
                  {description}
                  <span style={{ color: "red", marginLeft: 4 }}>*</span>
                </Typography>
              </Grid>

              {/* ปุ่มอัพโหลด */}
              <Grid
                item
                xs={12}
                md={2}
                sx={{
                  order: { xs: 2, md: 2 },
                  display: "flex",
                  justifyContent: { xs: "flex-start", md: "flex-end" },
                }}
              >
                <Box
                  {...getRootProps()}
                  sx={{ cursor: "pointer", width: { xs: "auto", md: "auto" } }}
                >
                  <input {...getInputProps()} />
                  <Button
                    variant="outlined"
                    component="span"
                    fullWidth={{ xs: false, md: false }}
                    sx={{
                      borderRadius: "15px",
                      px: 2.5,
                      py: 1,
                      boxShadow: "0px 2px 5px rgba(0,0,0,0.15)",
                      textTransform: "none",
                      bgcolor: "#f7f7f7",
                      borderColor: "#cccccc",
                      color: "#333333",
                      fontSize: { xs: 16, md: 16 },
                      fontFamily: "Prompt-Thin",
                    }}
                  >
                    อัพโหลด
                  </Button>
                </Box>
              </Grid>

              {/* ชื่อไฟล์ (อยู่บรรทัดถัดมาแบบไม่ทับปุ่ม) */}
              <Grid item xs={12} md={10} sx={{ order: { xs: 3, md: 3 } }}>
                {file && (
                  <Typography
                    variant="subtitle1"
                    onClick={() => handleClickOpen(file)}
                    sx={{
                      cursor: "pointer",
                      color: "#ff5e43",
                      textDecoration: "underline",
                      mt: { xs: 1, md: 0.5 }, // << แทน margin ติดลบ
                      wordBreak: "break-all", // กันชื่อไฟล์ยาวล้น
                      fontFamily: "Prompt-Thin",
                    }}
                  >
                    {file.name}
                  </Typography>
                )}
              </Grid>
            </Grid>
          );
        })}
      </Grid>

      {/* Dialog for File Preview */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogContent>
          <IconButton
            style={{ position: "absolute", right: 8, top: 8 }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          {selectedFile && selectedFile.type.startsWith("image/") && (
            <img
              src={selectedFile.preview}
              alt={selectedFile.name}
              style={{ width: "100%", height: "auto" }}
            />
          )}
          {selectedFile && selectedFile.type === "application/pdf" && (
            <object
              data={selectedFile.preview}
              type="application/pdf"
              width="100%"
              height="500px"
            >
              <p>PDF preview not available.</p>
            </object>
          )}
        </DialogContent>
      </Dialog>
      <BootstrapModal
        show={completedModal}
        backdrop="static"
        // size="md"
        // style={{}}
        className="backdrop-alert"
        contentClassName="modal-alert"
      >
        <BootstrapModal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={toggleImg ? greenCheck : remove}
              alt="check-icon"
              className="modal-image-size"
            />
          </div>

          <li
            className="body-list-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col
              xl={12}
              md={12}
              xs={12}
              style={{
                display: "flex",
                marginTop: 5,
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div className="font-modal">{textModal}</div>
            </Col>
          </li>
          <div className="d-flex justify-content-center flex-wrap">
            <button
              className="btn-checkout-modal w-20 p-2 bold"
              onClick={() => {
                if (toggleImg) {
                  navigate("/personal");
                } else {
                  setCompletedModal(false);
                }
              }}
            >
              กลับ
            </button>
          </div>
        </BootstrapModal.Body>
      </BootstrapModal>
    </div>
  );
};

export default PreviewMore20;
